<template>
  <div>
    <pageTitle :extinfo="extinfo"></pageTitle>
    <div class="works-content">
      <div class="user-works-box">
          <div class="works-list">
            <template
                v-for="(item, index) in worksList">
              <works
                @prioimg="toWorkDetail"
                :item="item"
                :key="index"
              ></works>
            </template>
          </div>
        </div>
      <noMore v-show="worksList.length > 0"></noMore>
    </div>
    <pageFoot :extinfo="extinfo" v-show="isSuspension"></pageFoot>
  </div>
</template>
<script>
import { getGalleryWorkeList } from '@/api/gallery'
import { getArtistWorks } from '@/api/artist'
import { wexinShare, changeTitleClick } from '@/utils/utils'
import Works from '@/components/works/works.vue'
import pageTitle from '@/components/pageTitle/pageTitle.vue'
import pageFoot from '@/components/pageFoot/pageFoot.vue'
import noMore from '@/components/noMore/noMore.vue'
import { queryShart } from '@/api/user'
export default {
  name: 'workLib',
  components: {
    noMore,
    Works,
    pageTitle,
    pageFoot
  },
  data () {
    return {
      userId: 0,
      name: '',
      worksList: [], // 艺术家作品
      imageList: [],
      isSuspension: false,
      extinfo: 'yslt://?name=galleryPerson&'
    }
  },
  async created () {
    this.getA()
    const title = this.name + '的作品库'
    changeTitleClick(title)
    if (this.name === '云上兰亭') {
      await this.getWorkeList()
    } else {
      await this.getArtistWorks()
    }
    this.weixin()
    this.extinfo = this.extinfo + `userId=${this.userId}`
  },
  mounted () {
    // 可以在这里面直接进行滚动条的获取
    window.addEventListener('scroll', this.scrollHandle)
  },
  methods: {
    // 微信二次分享
    async weixin () {
      const res = await queryShart({ url: `${location.href.split('#')[0].toString()}` })
      console.log(res)
      this.$nextTick(() => {
        wexinShare(res.result, {
          title: this.name + '的作品库',
          desc: this.name + '的作品库',
          link: `http://room.yslt.art/SharePageTest/?userId=${this.userId}&name=${this.name}#/workLib`,
          imgUrl: this.worksList[0].coverUrl
        })
      })
    },
    scrollHandle (e) {
      const top = e.srcElement.scrollingElement.scrollTop // 获取页面滚动高度
      if (top > 200) {
        this.isSuspension = true
      } else {
        this.isSuspension = false
      }
    },
    toWorkDetail (id) {
      if (this.name === '云上兰亭') {
        let position = 0
        this.worksList.forEach((item, index) => {
          if (item.id === id) {
            position = index
          }
        })
        this.ImagePreview({ images: this.imageList, startPosition: position })
      } else {
        const url = `http://room.yslt.art/SharePageTest/?id=${id}&jump=1#/workDetail`
        window.location.href = url
      }
    },
    // 获取艺术家作品
    async getArtistWorks () {
      try {
        const res = await getArtistWorks(this.userId)
        this.worksList = res.result
        this.worksList.forEach((item, index) => {
          this.imageList[index] = item.coverUrl
        })
      } catch (error) {
        console.log('获取艺术家作品失败', error)
      }
    },
    // 获取官方美术馆作品列表
    async getWorkeList () {
      try {
        const that = this
        const res = await getGalleryWorkeList('1544991314419613698')
        this.worksList = res.result
        this.worksList.forEach((item, index) => {
          that.imageList[index] = item.coverUrl
        })
      } catch (error) {
        console.log('获取作品列表失败', error)
      }
    },
    // 预览图片
    proImag (img) {
      let position = 0
      this.imageList.forEach((item, index) => {
        if (item === img[0]) {
          position = index
        }
      })
      this.ImagePreview({ images: this.imageList, startPosition: position })
    },
    // 获取url参数
    getA () {
      const geturl = window.location.href
      const seturl = geturl.split('#')[0]
      const getqyinfo = seturl.split('?')[1]
      const getqys = getqyinfo.split('&')
      const obj = {} // 创建空对象，接收截取的参数
      for (let i = 0; i < getqys.length; i++) {
        const item = getqys[i].split('=')
        const key = item[0]
        const value = item[1]
        obj[key] = value
      }
      this.userId = obj.userId
      this.name = decodeURIComponent(obj.name)
    }
  }
}
</script>
<style lang="scss" scoped>
.works-content {
    padding: 10px 17px 30px 17px;
}
.user-works-box {
    margin-top: 6px;
    background-color: #fff;
    .works-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      padding: 20px 10px;

    }
    .works-list {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
.nowork {
  width: 100%;
  text-align: center;
  .noworktips {
    color: #999;
    font-size: 12px;
    margin-top: 12px;
  }
}
</style>
